// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"557":"221ee4f4","980":"413d7281"}[chunkId] + ".css";
};